module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_calculator-404f9ad173a48d57f8160518d23f6ffe.svg";